module.exports = __webpack_public_path__ + "media/step3_Kernaufgaben_animation.c95be19b.webm";